/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../utils/SkeletonSettings";
import React from "react";

export const RecipeListHeaderSkeleton = (props) => (
    <ContentLoader
        height={32}
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        {...props}>

        {/* Titles */}
        <rect x="70%" y="12" rx="3" ry="3" width="30%" height="10"/>

    </ContentLoader>
);

